import { VatTypeEnum } from "../enums/VatTypeEnum";
import { PurchaseOrderStatusEnum } from "../enums/PurchaseOrderStatusEnum";
import { VatTaxationType } from "../enums/VatTaxationType";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { AmountTypeEnum, PaymentRequestPriorityTypeEnum, PaymentRequestStatusTypeEnum } from "../components/Pages/Documents/PaymentRequests/dtos/Enum/PaymentRequestPriority";
import { IncomingCashListNoSplit } from "../components/Pages/Documents/IncomingCashs/dtos/Enum/IncomingCash";
import { depreciationMethodTypeEnum } from "../dtos/documents/FixedAssetsTakeInAccounts/depreciationMethodTypeEnum";
import { GetEnumTypeForPaymentIncomeReceiversInformation, GetEnumTypeForPaymentTypeInformation } from "../components/Pages/Catalogs/WithHoldingTaxRate/WithHoldingTaxRateEnum";
import { IOutgoingBankPaymentOperationTypeEnum } from "src/components/Pages/Documents/ExpenseBanks/dtos/IOutgoingBankPaymentOperationTypeEnum";
import { CashierShiftStatus } from "../dtos/catalogs/CashierShift/CreateCashierShiftDto";
import { DeviceTypeEnum } from "../dtos/catalogs/Device/CreateDeviceDto";
import {
  DistributionOfLandedCostsRuleEnum
} from "../enums/Documents/DistributionOfLandedCost/DistributionOfLandedCostsRuleEnum";
import {
  IDistributionOfLandedCostsMethodEnum
} from "../enums/Documents/DistributionOfLandedCost/IDistributionOfLandedCostsMethodEnum";
import { IncomingBankPaymentOperationTypeEnum } from "src/components/Pages/Documents/IncomingBanks/dtos/IncomingBankPaymentOperationTypeEnum";
import { WriteOffGoodsOperationTypeEnum } from "src/components/Pages/Documents/Warehouse/WriteOffGoods/dtos/WriteOffGoodsOperationTypeEnum";
import { PaymentRequestOperationTypeEnum } from "src/components/Pages/Documents/PaymentRequests/dtos/PaymentRequestOperationTypeEnum";
import { OutgoingCashOperationTypeEnum } from "src/components/Pages/Documents/ExpenseCashs/dtos/OutgoingCashOperationTypeEnums";
import { IncomingCashOperationTypeEnum } from "src/components/Pages/Documents/IncomingCashs/dtos/IncomingCashOperationTypeEnums";

const getDistributionOfLandingCostsRuleEnum = (t:any) => {
   
    return [
        { id: DistributionOfLandedCostsRuleEnum.AccordingToTheAmount, name: t("by Amount") },
        { id: DistributionOfLandedCostsRuleEnum.AccordingToTheQuantity, name: t("by Quantity") },
        { id: DistributionOfLandedCostsRuleEnum.AccordingToTheWeight, name: t("by Weight") },
    ];
}

const GetVatTypeArrayForLookup = () => {
  const { t } = useTranslation();

  return [
    { id: VatTypeEnum.VatNo, name: "VatNo" },
    { id: VatTypeEnum.Vat0, name: "Vat0" },
    { id: VatTypeEnum.Vat18, name: "Vat18" }
  ];
};
const GetPaymentRequestsForOperationTypes = () => {
  return [
    {
      id: PaymentRequestOperationTypeEnum.PaymentToTheSupplier,
      name: "Payment To The Supplier"
    },
    {
      id: PaymentRequestOperationTypeEnum.DisbursmentOfMoney,
      name: "Disbursment Of Money"
    },
    {
      id: PaymentRequestOperationTypeEnum.CustomsFee,
      name: "Customs Fee"
    },
    {
      id: PaymentRequestOperationTypeEnum.PaymentToEmployee,
      name: "Payment To Employee"
    },
    {
      id: PaymentRequestOperationTypeEnum.PaymentOnCreditsAndLoansReceived,
      name: "Payment On Credits And Loans Received"
    },
    {
      id: PaymentRequestOperationTypeEnum.TransferMoneyBetweenTheOrganizationAndTheBranch,
      name: "Transfer Money Between The Organization And The Branch"
    },
    {
      id: PaymentRequestOperationTypeEnum.IssuanceOfALoanToACounterparty,
      name: "Issuance Of A Loan To A Counter party"
    },
    {
      id: PaymentRequestOperationTypeEnum.IssuingALoanToAnEmployee,
      name: "Issuing A Loan To An Employee"
    },
    {
      id: PaymentRequestOperationTypeEnum.CurrencyConversion,
      name: "Currency Conversion"
    },
    {
      id: PaymentRequestOperationTypeEnum.RefundOfPaymentToTheClient,
      name: "Refund Of Payment To The Client"
    },
    {
      id: PaymentRequestOperationTypeEnum.InternalTransfer,
      name: "Internal Transfer"
    },
    {
      id: PaymentRequestOperationTypeEnum.OtherExpenses,
      name: "Other Expenses"
    }
  ];
};
const GetOutgoingCashPaymentType = () => {
  return [
    {
      id: OutgoingCashOperationTypeEnum.paymentToVendor,
      name: "Payment to vendor"
    },
    {
      id: OutgoingCashOperationTypeEnum.paymentToAdvanceHolder,
      name: "Payment to advance holder"
    },
    {
      id: OutgoingCashOperationTypeEnum.payrollPaymentViaCashAccount,
      name: "Payroll payment via cash account"
    },
    {
      id: OutgoingCashOperationTypeEnum.cashDepositToBank,
      name: "Cash deposit to bank"
    },
    {
      id: OutgoingCashOperationTypeEnum.issueToAnotherCashAccount,
      name: "Issue to another cash account"
    },
    {
      id: OutgoingCashOperationTypeEnum.paymentForOptainedCreditsAndLoans,
      name: "Payment for optained credits and loans"
    },
    {
      id: OutgoingCashOperationTypeEnum.loanToEmployee,
      name: "Loan to employee"
    },
    {
      id: OutgoingCashOperationTypeEnum.loanToCounterparty,
      name: "Loan to counterparty"
    },
    {
      id: OutgoingCashOperationTypeEnum.currencyConversion,
      name: "Currency conversion"
    },
    { id: OutgoingCashOperationTypeEnum.otherExpenses, name: "Other expneses" },
    {
      id: OutgoingCashOperationTypeEnum.refundToCustomer,
      name: "Refund to customer"
    }
  ];
};
const GetIncomingCashsPaymentType = () => {
  return [
    {
      id: IncomingCashOperationTypeEnum.customerPayment,
      name: "Customer Payment"
    },
    {
      id: IncomingCashOperationTypeEnum.receivingFromBank,
      name: "Receiving from bank"
    },
    {
      id: IncomingCashOperationTypeEnum.transferFromAnotherCashAccount,
      name: "Transfer From Another Cash Account"
    },
    {
      id: IncomingCashOperationTypeEnum.withdrowalFromCashRegister,
      name: "Withdrowal From Cash Register"
    },
    {
      id: IncomingCashOperationTypeEnum.loanRepaymentByCounterparty,
      name: "Loan Repayment By Counterparty"
    },
    {
      id: IncomingCashOperationTypeEnum.loanRepaymentByEmployee,
      name: "Loan Repayment By Employee"
    },
    {
      id: IncomingCashOperationTypeEnum.currencyConversion,
      name: "Currency Conversion"
    },
    {
      id: IncomingCashOperationTypeEnum.otherPayment,
      name: "Other Payment"
    },
    {
      id: IncomingCashOperationTypeEnum.vendorRefund,
      name: "Vendor Refund"
    },
    {
      id: IncomingCashOperationTypeEnum.returnFromAdvanceHolder,
      name: "Return From Advance Holder"
    }
  ];
};
const GetIncomingBankPaymentType = () => {
  return [
    {
      id: IncomingBankPaymentOperationTypeEnum.CustomerPayment,
      name: "Customer Payment"
    },
    {
      id: IncomingBankPaymentOperationTypeEnum.TransferFromAnotherAccount,
      name: "Transfer From Another Account"
    },
    {
      id: IncomingBankPaymentOperationTypeEnum.CashDepositToBank,
      name: "Cash Deposit To Bank"
    },
    {
      id: IncomingBankPaymentOperationTypeEnum.LoanRepaymentByCounterparty,
      name: "Loan Repayment By Counterparty"
    },
    {
      id: IncomingBankPaymentOperationTypeEnum.DepositInterest,
      name: "Deposit Interest"
    },
    {
      id: IncomingBankPaymentOperationTypeEnum.LoanRepaymentByEmployee,
      name: "Loan Repayment By Employee"
    },
    {
      id: IncomingBankPaymentOperationTypeEnum.CurrencyConversion,
      name: "Currency Conversion"
    },
    {
      id: IncomingBankPaymentOperationTypeEnum.OtherPayment,
      name: "Other Payment"
    },
    {
      id: IncomingBankPaymentOperationTypeEnum.VendorRefund,
      name: "Vendor Refund"
    },
    {
      id: IncomingBankPaymentOperationTypeEnum.ReturnFromAdvanceHolder,
      name: "Return From Advance Holder"
    }
  ];
};
const GetOutgoingBankPaymentType = () => {
  return [
    {
      id: IOutgoingBankPaymentOperationTypeEnum.PaymentToVendor,
      name: "Payment To Vendor"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.paymentToAdnavceHolder,
      name: "Payment To Advance Holder"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.customsFee,
      name: "Customs Fee"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.payrolPaymentToBankAccounts,
      name: "Payrol Payment To Bank Accounts"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.cashTransferToOtherAccount,
      name: "Cash Transfer To Other Account"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.cashWithdrowalWithFromBank,
      name: "Cash Withdrowal With From Bank"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.repaymentOfLoansAndBorrowingsReceived,
      name: "Repayment Of Loans And Borrowings Received"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.transferToDeposits,
      name: "Transfer To Deposits"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.loanToCounterparty,
      name: "Loan To Counter party"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.loanToEmployee,
      name: "Loan To Employee"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.currencyConversion,
      name: "Currency Conversion"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.otherExpenses,
      name: "Other Expenses"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.refundToCustomer,
      name: "Refund To Customer"
    },
    {
      id: IOutgoingBankPaymentOperationTypeEnum.intercopanyTransfer,
      name: "Intercompany Transfer"
    }
  ];
};
const GetOutgoingBankCashListSplitTypeEnum = () => {
  return [
    { id: IncomingCashListNoSplit.AsAList, name: "As a list" },
    { id: IncomingCashListNoSplit.NoSplit, name: "No split" }
  ];
};

const GetVatTypeDistributionRule = () => {
  return [{ name: "0" }, { name: "18%" }, { name: "No VAT" }];
};

const IncludesVATOperationType = () => {
  return [
    { id: 0, name: "Yes" },
    { id: 0, name: "No" }
  ];
};

const GetGenderStatusTypeEnum = () => {
  return [
    {
      id: 0,
      name: "Male"
    },
    { id: 1, name: "Femal" }
  ];
};
const getDistributionLandedCostsMethodEnum = (t:any) => {
  return [
    { id: IDistributionOfLandedCostsMethodEnum.Auto, name: t("Auto") },
    { id: IDistributionOfLandedCostsMethodEnum.Manual, name: t("Manual") }
  ];
};

const GetPurchaseTypeArrayForLookup = () => {
  return [
    { id: PurchaseOrderStatusEnum.open, name: "Open" },
    { id: PurchaseOrderStatusEnum.closed, name: "Closed" },
    { id: PurchaseOrderStatusEnum.purchased, name: "Purchased" }
  ];
};

const GetVatTaxationTypeArrayForLookup = () => {
  return [
    { id: VatTaxationType.IsSubjectToVat, name: "IsSubjectToVat" },
    { id: VatTaxationType.IsNotSubjectToVat, name: "IsNotSubjectToVat" }
  ];
};

const GetWriteOfGoodsOperationTypeEnums = () => {
  return [
    {
      id: WriteOffGoodsOperationTypeEnum.WriteOffSpendingMaterial,
      name: t("WriteOffSpendingMaterial")
    },
    {
      id: WriteOffGoodsOperationTypeEnum.TaxableWriteOff,
      name: t("TaxableWriteOff")
    },
    {
      id: WriteOffGoodsOperationTypeEnum.WriteOffWithPayment,
      name: t("WriteOffWithPayment")
    }
  ];
};
const GetIncomingCashOperationType = () => {
  return [
    {
      id: PaymentRequestPriorityTypeEnum.High,
      name: "High"
    },
    {
      id: PaymentRequestPriorityTypeEnum.Average,
      name: "Average"
    },
    {
      id: PaymentRequestPriorityTypeEnum.Low,
      name: "Low"
    }
  ];
};
const GetPrincipalOperationType = () => {
  return [
    { id: AmountTypeEnum.Principal, name: "Principal" },
    { id: AmountTypeEnum.PrincipalDebt, name: "Principal Debt" }
  ];
};

const GetPaymentRequestsStatus = () => {
  return [
    {
      id: PaymentRequestStatusTypeEnum.Confirmed,
      name: "Confirmed"
    },
    {
      id: PaymentRequestStatusTypeEnum.NotConfirmed,
      name: "Average"
    },
    {
      id: PaymentRequestStatusTypeEnum.Paid,
      name: "Paid"
    },
    {
      id: PaymentRequestStatusTypeEnum.Rejected,
      name: "Rejected"
    }
  ];
};
const GetArApObjectTypeEnum = () => {
  return [
    { id: 0, name: "PurchaseOrder" },
    { id: 1, name: "ExpenseBankPayment" },
    { id: 2, name: "Contract" }
  ];
};
const GetDepreciationMethodEnum = () => {
  return [
    {
      id: depreciationMethodTypeEnum.StraightLineByDays,
      name: "Straight Line By Days"
    },
    { id: depreciationMethodTypeEnum.IsNotAccrued, name: "Is Not Accrued" },
    { id: depreciationMethodTypeEnum.StraightLine, name: "Straight Line" }
  ];
};
const GetEnumTypeForPaymentType = () => {
  return [
    { id: GetEnumTypeForPaymentTypeInformation.StraightLineByDays, name: "Straight Line By Days" },
    { id: GetEnumTypeForPaymentTypeInformation.Salary, name: "Salary" },
    { id: GetEnumTypeForPaymentTypeInformation.Dividend, name: "Dividend" },
    { id: GetEnumTypeForPaymentTypeInformation.Percent, name: "Percent" },
    { id: GetEnumTypeForPaymentTypeInformation.Profit, name: "Profit" },
    { id: GetEnumTypeForPaymentTypeInformation.Scholarship, name: "Scholarship" },
    { id: GetEnumTypeForPaymentTypeInformation.Other, name: "Other" },
    { id: GetEnumTypeForPaymentTypeInformation.PaymentOfService, name: "Payment of Service" },
    { id: GetEnumTypeForPaymentTypeInformation.Royalties, name: "Royalties" },
    { id: GetEnumTypeForPaymentTypeInformation.ReturnedPension, name: "Returned Pension" },
    { id: GetEnumTypeForPaymentTypeInformation.PaymentTaxableBySocialTax, name: "Payment Taxable by Social Tax" },
    { id: GetEnumTypeForPaymentTypeInformation.PaymentOfLeasingService, name: "Payment of Leasing Service" },
    { id: GetEnumTypeForPaymentTypeInformation.PaymentToOwnerOfTaxableIncomeOfFellowship, name: "Payment to Owner of Taxable Income of Fellowship" },
    { id: GetEnumTypeForPaymentTypeInformation.OilOrGasOperations, name: "Oil or Gas Operations" },
    { id: GetEnumTypeForPaymentTypeInformation.InternationalShipping, name: "International Shipping" }
  ];
};
const GetEnumTypeForPaymentIncomeReceivers = () => {
  return [
    { id: GetEnumTypeForPaymentIncomeReceiversInformation.NaturalPersonsEmployed, name: "Natural Persons Employed" },
    { id: GetEnumTypeForPaymentIncomeReceiversInformation.NonTaxpayerPerformingServices20Percent, name: "Non-taxpayer Natural Persons Performing Services (Income Taxed 20%)" },
    { id: GetEnumTypeForPaymentIncomeReceiversInformation.NaturePersonsIncomeTaxedByBuyingPerson, name: "Nature Persons Income Taxed by Buying Person (Withholding Tax at 3%)" },
    { id: GetEnumTypeForPaymentIncomeReceiversInformation.NonTaxpayerPerformingServices5Percent, name: "Non-taxpayer Natural Persons Performing Services (Income Taxed 5%)" },
    { id: GetEnumTypeForPaymentIncomeReceiversInformation.NaturalPersonsInPossessionOfHotelShares, name: "Natural Persons in Possession of Hotel Shares" },
    { id: GetEnumTypeForPaymentIncomeReceiversInformation.OtherNaturalPersons, name: "Other Natural Persons" },
    { id: GetEnumTypeForPaymentIncomeReceiversInformation.LegalEntitiesRegisteredInOffshoreCountries, name: "Legal Entities Registered in Offshore Countries" },
    { id: GetEnumTypeForPaymentIncomeReceiversInformation.NaturalPersonsRegisteredInOffshoreCountries, name: "Natural Persons Registered in Offshore Countries" },
    { id: GetEnumTypeForPaymentIncomeReceiversInformation.NonResidentLegalEntitiesWithoutPE, name: "Non-resident Legal Entities without Permanent Establishment in Georgia" },
    { id: GetEnumTypeForPaymentIncomeReceiversInformation.NonResidentNaturalPersonsWithoutPE, name: "Non-resident Natural Persons without Permanent Establishment in Georgia" },
    {
      id: GetEnumTypeForPaymentIncomeReceiversInformation.IndividualNonResidentSubContractorOilGas,
      name: "Individual Non-resident Sub-contractor Performing Operations of Oil and Gas"
    },
    {
      id: GetEnumTypeForPaymentIncomeReceiversInformation.PaymentsFromEntrepreneurIndividualIntlTransportComm,
      name: "Payments from Entrepreneur Individual on Services Received from International Transport or International Communications"
    },
    {
      id: GetEnumTypeForPaymentIncomeReceiversInformation.LegalEntityNonResidentSubContractorOilGas,
      name: "Legal Entity Non-resident Sub-contractor Performing Operations of Oil and Gas"
    },
    {
      id: GetEnumTypeForPaymentIncomeReceiversInformation.PaymentsFromLegalEntityIntlTransportComm,
      name: "Payments from Legal Entity/Organizations on Services Received from International Transport or International Communications"
    }
  ];
};
const AccrualDetailBelongToTypeEnum = () => {
  return [
    { id: 0, name: "OperatingActivity" },
    { id: 1, name: "InvestmentActivity" },
    { id: 2, name: "FinancialActivity" }
  ];
};
const CashierShiftStatusTypeEnum = () => {
  return [
    {
      id: CashierShiftStatus.Open,
      name: "Opened"
    },
    {
      id: CashierShiftStatus.Closed,
      name: "Closed"
    }
  ];
};
const CategoryOfFixedAssetTestTypeEnum = () => {
  return [
    { id: 0, name: "test1" },
    { id: 1, name: "test2" },
    { id: 2, name: "test2" }
  ];
};
const ProductionTypeEnum = () => {
  return [
    {
      id: DeviceTypeEnum.MagneticCardReader,
      name: "Magnetic Card Reader"
    },
    {
      id: DeviceTypeEnum.scanner,
      name: "Scanner"
    },
    {
      id: DeviceTypeEnum.FiscalRegistrar,
      name: "Fiscal Registrar"
    },
    {
      id: DeviceTypeEnum.AcquiringTerminal,
      name: "Acquiring Terminal"
    },
    {
      id: DeviceTypeEnum.ScaleWithLabelPrinting,
      name: "Scale With Label Printing"
    },
    {
      id: DeviceTypeEnum.UserScreen,
      name: "User Screen"
    }
  ];
};
const FixedAssetDetailTestTypeEnum = () => {
  return [
    { id: 0, name: "test1" },
    { id: 1, name: "test2" },
    { id: 2, name: "test3" }
  ];
};

export const EnumHelper = {
  GetVatTypeArrayForLookup,
  GetPurchaseTypeArrayForLookup,
  GetVatTaxationTypeArrayForLookup,
  GetVatTypeDistributionRule,
  GetGenderStatusTypeEnum,
  GetWriteOfGoodsOperationTypeEnums,
  IncludesVATOperationType,
  GetPaymentRequestsForOperationTypes,
  GetIncomingCashOperationType,
  GetPaymentRequestsStatus,
  GetOutgoingBankCashListSplitTypeEnum,
  GetPrincipalOperationType,
  GetArApObjectTypeEnum,
  GetEnumTypeForPaymentType,
  GetDepreciationMethodEnum,
  GetEnumTypeForPaymentIncomeReceivers,
  GetOutgoingBankPaymentType,
  GetOutgoingCashPaymentType,
  GetIncomingBankPaymentType,
  GetIncomingCashsPaymentType,
  AccrualDetailBelongToTypeEnum,
  CashierShiftStatusTypeEnum,
  CategoryOfFixedAssetTestTypeEnum,
  ProductionTypeEnum,
  FixedAssetDetailTestTypeEnum,
  getDistributionOfLandingCostsRuleEnum,
  getDistributionLandedCostsMethodEnum
};
